import { TransactionsInProps } from 'modules/clients/types/transaction-summary';
import styles from '../transaction-summary.module.scss';
import TransactionSummaryHeadingRow from 'modules/clients/components/atoms/transaction-summary-rows/TransactionSummaryHeadingRow';
import TransactionSummaryRow from 'modules/clients/components/atoms/transaction-summary-rows/TransactionSummaryRow';

const TransactionsIn = ({
  collectiveInterest,
  moneyMarketInterest,
  dividends,
  otherIncome,
  income
}: TransactionsInProps) => {
  return (
    <div className={styles.container}>
      <TransactionSummaryHeadingRow
        testid='transactionSummaryTransactionsIn'
        data-testid='transactionSummaryTransactionsInHeadingRow'
        heading='Transactions: in'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryCollectiveInterestRow'
        heading='Interest (collective investments)'
        amount={collectiveInterest}
        testid='transactionSummaryCollectiveInterest'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryMarketFundsInterestRow'
        heading='Interest (money market funds)'
        amount={moneyMarketInterest}
        testid='transactionSummaryMarketFundsInterest'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryDividendsRow'
        heading='Dividends'
        amount={dividends}
        testid='transactionSummaryDividends'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryOtherIncomeRow'
        heading='Other income'
        amount={otherIncome}
        testid='transactionSummaryOtherIncome'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryIncomeRow'
        heading='Income'
        amount={income}
        testid='transactionSummaryIncome'
      />
    </div>
  );
};

export default TransactionsIn;
